var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('iframe',{ref:"myIframe",staticClass:"iframe-container",attrs:{"src":_vm.htmlContent2,"frameborder":"0"}}),_c('hr')])])
}
var staticRenderFns = []

export { render, staticRenderFns }